module.exports = {
  columWidth: 350,
  jobTopMagin: 30,
  jobIconFit: 52,
  jobHeight: 56,
  jobWidth: 200,
  bttHeight: 20,
  bttWidth: 60,
  getWFjobsId: (ls_dependencies) =>{
    if (!ls_dependencies || ls_dependencies === "") return "";
    try {
        const wf =  typeof ls_dependencies == 'string' ? JSON.parse(ls_dependencies) : ls_dependencies;
        let jobs = [];
        if (wf && Array.isArray(wf)) {
            for (let i=0; i<wf.length;i++){
            const column = wf[i];
            for (let j=0; j<column.length;j++){
                const job = column[j];
                jobs.push(job.job_id)

            }
            }
        }
        jobs = JSON.stringify(jobs);
        jobs = jobs.substring(1,jobs.length-1);
        return jobs;
    } catch (e) {
        console.error("Error parsing dependencies:", e);
        return "";
    }
  }
}
